class Modal {
    constructor() {
        this.buttonList = document.querySelectorAll('[data-modal]');
        this.buttonHrefList = document.querySelectorAll('[href^="#modal-"]');
        this.closeList = document.querySelectorAll('.js-modal-close');
        this.activeModal = null; // to keep track of the active modal
    }

    init() {
        if (this.buttonList.length > 0 || this.buttonHrefList.length > 0) {
            this.bindEvents();
        }
    }

    bindEvents() {

        const stopVideos = () => {
            document.querySelectorAll('iframe').forEach(v => { v.src = v.src });
            document.querySelectorAll('video').forEach(v => { v.pause() });
        };

        const openModal = (contentTarget) => {
            const modalContents = document.querySelectorAll('[data-modal-content]');

            modalContents.forEach((content) => {
                if (content.getAttribute('data-modal-content') === contentTarget) {
                    content.classList.add('is-active');
                    this.activeModal = content; // set active modal
                } else {
                    content.classList.remove('is-active');
                }
            });
        };

        const closeModal = () => {
            const modalContents = document.querySelectorAll('[data-modal-content]');
            stopVideos();
            modalContents.forEach((modal) => {
                modal.classList.remove('is-active');
            });
            this.activeModal = null; // reset active modal
        };

        document.body.addEventListener('click', (event) => {
            let element = event.target;

            if (!element.matches('[data-modal]') && !element.matches('[href^="#modal-"]')) {
                let parentElement = element.closest('[data-modal]');
                if (!parentElement) {
                    parentElement = element.closest('[href^="#modal-"]');
                }
                if (parentElement) {
                    element = parentElement;
                }
            }

            if (element && (element.matches('[data-modal]') || element.matches('[href^="#modal-"]'))) {
                event.preventDefault();

                // handle kidsmobile special case
                if (document.querySelector('.js-sweepstake-modal')) {
                    let sweepstakeContainer = document.querySelector('.js-sweepstake');
                    if (sweepstakeContainer) {
                        sweepstakeContainer.dataset.openerTarget = element.dataset.href || '';
                    }
                }

                let contentTarget = element.dataset.hasOwnProperty('modal') ? element.dataset.modal : element.getAttribute('href').substr(1);
                openModal(contentTarget);
            }

            if (element && element.classList.contains('js-modal-close')) {
                closeModal();
            }
        });

        this.closeList.forEach((button) => {
            button.addEventListener('click', (event) => {
                stopVideos();
                window.setTimeout(() => {
                    event.target.parentElement.classList.remove('is-active');
                }, 500);
            });
        });

        // ESC key closes modal
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && this.activeModal) {
                closeModal();
            }
        });

        // temporary script for pannenhilfe and jugend
        if (window.location.href.indexOf('#section-video-membership') !== -1) {
            const modalVideo = document.querySelector('[data-modal-content="modal-video"]');
            if (modalVideo) {
                openModal('modal-video');
            }
        }

        // Check if there is a hash in the URL that starts with '#modal-'
        if (window.location.hash.startsWith('#modal-')) {
            // Get the specific modal ID from the URL
            const modalId = window.location.hash.substring(1); // Remove the '#' from the hash

            // Find the modal element using the data attribute
            const modalElement = document.querySelector(`[data-modal-content="${modalId}"]`);

            // If the modal element exists, add the 'is-active' class to make it visible
            if (modalElement) {
                openModal(modalId);
            }
        }
    }
}

export default new Modal();